module.exports = __webpack_public_path__ + "img/96.6.CODm.8b0c1762.png";